import type { ReactNode } from 'react'
import { readableError } from '@solum/format'

/**
 * A failure a HOST handed the kit, as something a person may read (#3012).
 *
 * The kit's refused / error slots say "already worded by the host" — and the
 * UI/UX review found hosts handing them `error.message`, so the transport
 * envelope (`solum sdk: 403 — {"code":"42501", … GRANT SELECT ON …}`) reached
 * the screen through a kit component. The kit now screens at its own render
 * boundary: a STRING goes through `readableError` (a human sentence is kept,
 * machine text becomes `fallback`); an ELEMENT is the host's own composition
 * and is drawn as given.
 */
export function readableProblem(problem: ReactNode, fallback?: string): ReactNode {
  return typeof problem === 'string' ? readableError(problem, fallback) : problem
}
